/**
 * Painel das variáveis disponíveis no texto padronizado
 *
 * O catálogo vem do backend e é a lista EXIBIDA: token, o que ele significa e
 * um exemplo do valor como ele sai impresso. Clicar insere `{{token}}` no
 * conteúdo, para ninguém precisar decorar a grafia.
 *
 * @version 2026.1.0
 */
import React from 'react';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { DocumentVariable } from '../../../types/standardText';

interface VariablePanelProps {
  variables: DocumentVariable[];
  onInsert: (token: string) => void;
  disabled?: boolean;
}

export const VariablePanel: React.FC<VariablePanelProps> = ({
  variables,
  onInsert,
  disabled = false,
}) => {
  if (variables.length === 0) {
    return null;
  }

  return (
    <Paper variant="outlined" sx={{ p: 2, height: '100%', overflowY: 'auto', maxHeight: 320 }}>
      <Typography variant="subtitle2" gutterBottom>
        Variáveis disponíveis
      </Typography>
      <Typography variant="caption" color="text.secondary" component="p" sx={{ mb: 1 }}>
        Clique para inserir onde o cursor está no conteúdo.
      </Typography>

      <Stack spacing={0.5}>
        {variables.map((variable) => (
          <Button
            key={variable.token}
            size="small"
            variant="text"
            disabled={disabled}
            onClick={() => onInsert(variable.token)}
            sx={{ justifyContent: 'flex-start', textAlign: 'left', textTransform: 'none' }}
          >
            <Box>
              <Typography variant="body2">{variable.label}</Typography>
              <Typography variant="caption" color="text.secondary" component="span">
                {`{{${variable.token}}} · ex.: ${variable.example}`}
              </Typography>
            </Box>
          </Button>
        ))}
      </Stack>
    </Paper>
  );
};

export default VariablePanel;
